import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TsplatFallGaussianIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M8.51 5.88H7.5C7.15759 5.88 6.88 6.15759 6.88 6.5V7.51C6.88 7.85242 7.15759 8.13 7.5 8.13H8.51C8.85242 8.13 9.13 7.85242 9.13 7.51V6.5C9.13 6.15759 8.85242 5.88 8.51 5.88Z"
        fill={color}
      />
      <path
        d="M7.41 10.88H6.4C6.05758 10.88 5.78 11.1576 5.78 11.5V12.51C5.78 12.8524 6.05758 13.13 6.4 13.13H7.41C7.75241 13.13 8.03 12.8524 8.03 12.51V11.5C8.03 11.1576 7.75241 10.88 7.41 10.88Z"
        fill={color}
      />
      <path
        d="M5.38 15.88H4.37C4.02758 15.88 3.75 16.1576 3.75 16.5V17.51C3.75 17.8524 4.02758 18.13 4.37 18.13H5.38C5.72242 18.13 6 17.8524 6 17.51V16.5C6 16.1576 5.72242 15.88 5.38 15.88Z"
        fill={color}
      />
      <path
        d="M1.63 18.75H0.62C0.277583 18.75 0 19.0276 0 19.37V20.38C0 20.7224 0.277583 21 0.62 21H1.63C1.97242 21 2.25 20.7224 2.25 20.38V19.37C2.25 19.0276 1.97242 18.75 1.63 18.75Z"
        fill={color}
      />
      <path
        d="M23 19C20.32 19 19.27 15.94 17.96 11.27C16.82 7.2 15.64 3 12 3C11.45 3 11 3.45 11 4C11 4.55 11.45 5 12 5C13.98 5 14.88 7.7 16.03 11.81C17.24 16.12 18.6 21 23 21C23.55 21 24 20.55 24 20C24 19.45 23.55 19 23 19Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TsplatFallGaussianIcon.displayName = 'TsplatFallGaussianIcon';
